import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-english-business-course',
    templateUrl: './english-business-course.component.html',
    styleUrls: ['./english-business-course.component.scss'],
    standalone: false
})
export class EnglishBusinessCourseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
